import {
  mapState
} from "vuex";

export default {
  computed: {
    ...mapState({
      roleUserData: state => state.main.userData,
      managerStorage: state => state.storage.managerStorage,
    })
  },
  data() {
    return {

    }
  },
  methods: {
    // 返回是否是管理员权限
    isSystemAdmin() {
      if (!this.roleUserData) {
        return false
      }
      let _isAdmin = false
      for (let i = 0; i < this.roleUserData.roles.length; i++) {
        if (this.roleUserData.roles[i].type == '0') {
          _isAdmin = true
          break
        }
      }
      return _isAdmin
    },
    // 判断是否有组权限
    backNavRole(lackKey) {
      if (!this.roleUserData) {
        return false
      }
      if (!lackKey || this.isSystemAdmin()) {
        return true
      }

      let backR = false
      for (let i = 0; i < this.roleUserData.roles.length; i++) {
        let _role = this.roleUserData.roles[i]
        for (let j = 0; j < _role.resources.length; j++) {
          let _key = _role.resources[j].sourceKey
          // console.log(_key + "===" + lackKey)
          if (_key.indexOf(lackKey) != -1) {
            backR = true
            break
          }
        }
        if (backR == true) {
          break
        }
      }

      return backR
    },
    // 返回是否有权限
    backRole(role) {
      if (!this.roleUserData) {
        return false
      }
      if (!role || this.isSystemAdmin()) {
        return true
      }

      let backR = false
      for (let i = 0; i < this.roleUserData.roles.length; i++) {
        let _role = this.roleUserData.roles[i]
        for (let j = 0; j < _role.resources.length; j++) {
          let _key = _role.resources[j].sourceKey
          if (_key == role) {
            backR = true
            break
          }
        }
        if (backR == true) {
          break
        }
      }
      return backR
    },
    // 判断是否在数组内
    isInArray(key, arr) {
      let _in = false
      for (let i = 0; i < arr.length; i++) {
        if (key == arr[i]) {
          _in = true
          break
        }
      }
      return _in
    },
    // 必须绝对管理员栏目权限，即某仓库管理员等
    mustManager(sub) {
      let _manager = false
      // 查看栏目是否需要绝对管理员
      if (sub.mustManager) {
        // 判断权限

        // 仓库相关
        // 需要是仓库管理员
        if (this.isInArray(sub.type, ['', 'materialInList', 'materialInDetailList', 'materialInventoryList', 'materialInventoryDetailList', 'realTimeList', 'storageSupplierList', 'materialOutList'])) {
          if (this.managerStorage.length > 0) {
            _manager = true
          }
        }
        // // 需要是二级仓库管理员
        // if (this.isInArray(sub.type, ['', ''])) {
        //   for (let i = 0; i < this.managerStorage.length; i++) {
        //     if (this.managerStorage[i].level === '2') {
        //       _manager = true
        //     }
        //   }
        // }


      } else {
        _manager = true
      }
      return _manager
    },
    // 判断是否是仓库管理员
    isThisHouseManager(houseId) {
      let _manager = false
      for (var i = 0; i < this.managerStorage.length; i++) {
        if (this.managerStorage[i].id == houseId) {
          _manager = true
          break
        }
      }
      return _manager
    },
  },
  watch: {

  }
}


// WEBPACK FOOTER //
// ./src/Mixins/role.js